import React from 'react';

interface ICheckboxProps {
  description: string | React.ReactNode;
  register: any;
  terms?: boolean;
}

export const CheckBox = ({ description, register, terms }: ICheckboxProps) => (
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  <label className="flex items-center gap-[8px] mt-[4px] cursor-pointer select-none">
    <div className="relative flex items-center justify-center flex-shrink-0">
      <input
        type="checkbox"
        className="peer appearance-none h-[20px] w-[20px] rounded-[4px] border border-base-black
      transition-all duration-200 cursor-pointer
      checked:bg-base-black checked:border-base-black
      hover:bg-[#EFEFF1] hover:border-[#818185]
      checked:hover:bg-[#2E2E30] checked:hover:border-[#2E2E30]"
        {...register()}
      />
      <svg
        className="absolute pointer-events-none hidden peer-checked:block text-white"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M2.5 6L5 8.5L9.5 3.5" />
      </svg>
    </div>

    <span className="text-base-black font-body text-[16px] font-regular leading-[140%]">
      {description}
    </span>
  </label>
);
